import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

import useForm from '../../../lib/hooks/useForm';
import { api } from '../../../lib/api';
import { useNotification } from '../../../shared/Notification/useNotification';

const updatePhoneNumber = ({ phoneNumber }) => {
  const data = {
    phone_number: phoneNumber,
  };

  return api({
    method: 'patch',
    url: '/api/account_settings/update_phone_number',
    data,
  });
};

const validationSchema = yup.object({
  number: yup.string(),
});

const usePhoneNumberForm = () => {
  const queryClient = useQueryClient();
  const { phoneNumber } = queryClient.getQueryData(['accountSettings']);
  const { showSuccess } = useNotification();
  const { mutate } = useMutation(updatePhoneNumber);
  const { t } = useTranslation('accountSettings');

  const initialValues = {
    phoneNumber,
  };

  const onSubmit = (values, { setFieldError, resetForm }) => {
    mutate(values, {
      onSuccess: ({ data }) => {
        queryClient.setQueryData(['accountSettings'], data.settings);
        showSuccess({
          content: data.message,
          title: t('phoneNumberForm.title'),
        });
        resetForm();
      },
      onError: ({ response }) => {
        const { errors } = response.data;
        setFieldError('phoneNumber', errors[0]);
      },
    });
  };

  const form = useForm({
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true,
  });

  return form;
};

export default usePhoneNumberForm;
